import type { NextWebVitalsMetric } from 'next/app';

// Measure and report web vitals that Next.js tracks to Axiom.
// See: https://nextjs.org/docs/advanced-features/measuring-performance
export function nextJsReportWebVitals(metric: NextWebVitalsMetric) {
  reportWebVitalsAxiom(metric);
}

function reportWebVitalsAxiom(metric: NextWebVitalsMetric) {
  const url = process.env.NEXT_PUBLIC_AXIOM_INGEST_ENDPOINT;

  if (!url) {
    return;
  }

  const body = JSON.stringify({
    route: window.__NEXT_DATA__.page,
    ...metric,
  });

  const sendBeacon =
    navigator.sendBeacon && navigator.sendBeacon.bind(navigator);

  try {
    sendBeacon(url, body);
  } catch {
    fetch(url, { body, method: 'POST', keepalive: true });
  }
}
